import React from 'react'
import { productTopOrderType } from '../../types/modules/product.type'
import { useTranslation } from 'react-i18next'
import { formatNumber } from '../../utils/formatNumber'
import EmptyData from '../ui/EmptyData'

type Props ={
    products:productTopOrderType[]
}

function TopFourProductsOrdered({products}:Props) {
    const {t} = useTranslation();
  return (
    <div className=' shadow-custom-light bg-[#FFFFFF] rounded-2xl p-6'>
        <h4 className=' text-Black font-medium text-[12px] capitalize'>{t("top_products_orderd",{num:formatNumber(4)})}</h4>
        {
            products.length === 0 ? <EmptyData/>
            :
            <div className='flex flex-col space-y-4 mt-4'>
            {
            products.map(prod=>{
                return <div key={prod.id+"rmk"} className='flex justify-between items-center'>
                    <div className=' flex items-center gap-3'>
                        <img 
                        className='w-[56px] h-[56px] rounded-xl'
                        src={prod.images[0].imageUrl} alt="" />
                        <h5 className='text-Black text-[14px] font-semibold capitalize'>{prod.languages[0].name}</h5>
                    </div>
                    <div className='flex gap-1 items-center'>
                        <span className=' text-DarkGrey3 font-black text-[16px]'>{prod.totalSold}</span>
                        <span className=' text-DarkGrey3 font-meduim capitalize text-[14px]'>{t("sold")}</span>
                    </div>
                </div>
            })
            }
        </div>
        }
    </div>
  )
}

export default TopFourProductsOrdered